"use strict";
/*
 * Created on 02 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueWithUnitConverter_1 = require("../../core/conversions/ValueWithUnitConverter");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var SelloutSupply_1 = require("../model/SelloutSupply");

var SelloutSupplyConverter_1 = require("./SelloutSupplyConverter");
/**
 * Implementation of {@link SelloutSupplyConverter}
 *
 * @author JMe
 */


var SelloutSupplyConverterImpl =
/*#__PURE__*/
function (_SelloutSupplyConvert) {
  _inherits(SelloutSupplyConverterImpl, _SelloutSupplyConvert);

  function SelloutSupplyConverterImpl() {
    _classCallCheck(this, SelloutSupplyConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutSupplyConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutSupplyConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        productId: conversions.toDocumentReferenceId(source.productId),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        type: source.type,
        availableSupply: conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        amount: conversions.asObjectOpt(source, 'amount', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        supplyLastInDays: source.supplyLastInDays,
        delistedFrom: source.delistedFrom ? conversions.fromDate(source.delistedFrom) : null,
        selloutDetected: conversions.fromDate(source.selloutDetected),
        lastPurchase: source.lastPurchase ? conversions.fromDate(source.lastPurchase) : null,
        promo: source.promo,
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        stateFlags: source.stateFlags.serialize(),
        processed: source.processed,
        endReasonExternalId: source.endReasonExternalId
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutSupply_1.SelloutSupply(SelloutSupply_1.SelloutSupply.schema.id.valueOf(conversions.documentToClassId(source)), SelloutSupply_1.SelloutSupply.schema.externalId.valueOfField(source), SelloutSupply_1.SelloutSupply.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SelloutSupply_1.SelloutSupply.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), SelloutSupply_1.SelloutSupply.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')), SelloutSupply_1.SelloutSupply.schema.type.valueOfField(source), conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)), conversions.asObjectOpt(source, 'amount', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)), SelloutSupply_1.SelloutSupply.schema.supplyLastInDays.valueOfField(source), SelloutSupply_1.SelloutSupply.schema.delistedFrom.valueOfField(source), SelloutSupply_1.SelloutSupply.schema.selloutDetected.valueOfField(source), SelloutSupply_1.SelloutSupply.schema.lastPurchase.valueOfField(source), SelloutSupply_1.SelloutSupply.schema.promo.valueOfField(source), SelloutSupply_1.SelloutSupply.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), SelloutSupply_1.SelloutSupply.schema.processed.valueOfField(source), SelloutSupply_1.SelloutSupply.schema.endReasonExternalId.valueOfField(source));
    }
  }]);

  return SelloutSupplyConverterImpl;
}(SelloutSupplyConverter_1.SelloutSupplyConverter);

exports.SelloutSupplyConverterImpl = SelloutSupplyConverterImpl;